import { render } from "./CourseForLargerGroups.vue?vue&type=template&id=35523f66&scoped=true"
import script from "./CourseForLargerGroups.vue?vue&type=script&lang=js"
export * from "./CourseForLargerGroups.vue?vue&type=script&lang=js"

import "./CourseForLargerGroups.vue?vue&type=style&index=0&id=35523f66&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35523f66"]])

export default __exports__